import { Box, styled } from '@mui/system';

export const Container = styled(Box)({
  backgroundColor: '#f9f9f9',
  padding: '78px 16px !important',
  maxWidth: '800px',
  margin: 'auto',
});
